import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericResultModel } from 'src/app/sharedFeatures/models/generic-result.model';
import { BaseHttpServiceService } from 'src/app/sharedFeatures/services/base-http-service.service';
import { CurrentUserService } from 'src/app/sharedFeatures/services/current-user.service';
import { SectionLightViewModel } from '../models/section-light-view-model.model';
import { SectionLookupSearchModel } from '../models/section-lookup-search-model.model';
import { SectionSearchModel } from '../models/section-search-model.model';
import {
  SectionLookupViewModel,
  SectionViewModel,
} from '../models/section-view-model.model';
import { SectionViewViewModel } from '../models/section-view-view-model.model';
import {
  SectionDto,
  SectionSummaryDto,
  ProjectDto,
} from '../models/section-summary-dto-view-model.model';

@Injectable({
  providedIn: 'root',
})
export class SectionService extends BaseHttpServiceService {
  private controller: string = `${this.baseUrl}/Section`;

  constructor(
    http: HttpClient,
    translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }
  search(
    model: SectionSearchModel
  ): Observable<GenericResultModel<SectionLightViewModel[]>> {
    let url: string = `${this.controller}/search`;
    return this.postData<GenericResultModel<SectionLightViewModel[]>>(
      url,
      model
    );
  }
  getSections(model: SectionSearchModel): Observable<SectionSummaryDto> {
    let url: string = `${this.controller}/getSections`;
    return this.postData<SectionSummaryDto>(url, model);
  }
  getSectionsStatuses(model: SectionSearchModel): Observable<SectionDto> {
    let url: string = `${this.controller}/getSectionsStatuses`;
    return this.postData<SectionDto>(url, model);
  }

  GetProjectsDueSoon(model: SectionSearchModel): Observable<ProjectDto[]> {
    let url: string = `${this.controller}/getProjectsDueSoon`;
    return this.postData<ProjectDto[]>(url, model);
  }
  getLookup(): Observable<SectionLookupViewModel[]> {
    let url: string = `${this.controller}/searchListLookup`;
    return this.postData<SectionLookupViewModel[]>(url, null);
  }

  /* getLookup(
  searchModel: SectionLookupSearchModel
): Observable<GenericResultModel<SectionLookupViewModel[]>> {
  let url: string = `${this.controller}/searchLookup`;
  return this.postData<GenericResultModel<SectionLookupViewModel[]>>(
    url,
    searchModel
  );
} */
  getById(id: any): Observable<SectionViewModel> {
    let url: string = `${this.controller}/get/${id}`;
    return this.getData<SectionViewModel>(url);
  }

  getViewById(id: any): Observable<SectionViewViewModel> {
    let url: string = `${this.controller}/details/${id}`;
    return this.getData<SectionViewViewModel>(url);
  }

  add(model: SectionViewModel): Observable<SectionViewModel> {
    let url: string = `${this.controller}/add`;
    return this.postData<SectionViewModel>(url, model);
  }

  update(model: SectionViewModel): Observable<SectionViewModel> {
    let url: string = `${this.controller}/update`;
    return this.postData<SectionViewModel>(url, model);
  }
  publishSection(id: number): Observable<SectionViewModel> {
    let url: string = `${this.controller}/publish-section/` + id;
    return this.postData<any>(url, null);
  }
  delete(id: any): Observable<any> {
    let url: string = `${this.controller}/delete/${id}`;
    return this.postData<any>(url, null);
  }
}
